import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const policyLinks = [
    { name: '\uC774\uC6A9\uC57D\uAD00', routerPath: '' },
    { name: '\uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68', routerPath: '' },
    { name: '\uCCAD\uC18C\uB144\uBCF4\uD638\uC815\uCC45', routerPath: '' },
    { name: '\uC6B4\uC601\uC815\uCC45', routerPath: '' },
    { name: '\uCFE0\uD0A4\uC815\uCC45', routerPath: '' },
    { name: '\uD504\uB77C\uC774\uBC84\uC2DC \uC13C\uD130', routerPath: '' },
    { name: '\uC11C\uBE44\uC2A4 \uB3D9\uC758', routerPath: '' },
    { name: '\uC815\uBCF4\uBCF4\uD638\uD604\uD669', routerPath: '' },
    { name: '\uD074\uB9B0\uC2E0\uACE0\uC13C\uD130', routerPath: '' },
]

const corporateInfo = [
    '\uC0C1\uD638 (\uC8FC)\uCF54\uB2F4',
    '\uC0AC\uC5C5\uC790 \uB4F1\uB85D\uBC88\uD638 349-88-03725',
    '\uD1B5\uC2E0\uD310\uB9E4\uC5C5\uC2E0\uACE0 \uC81C2026-\uC131\uB0A8\uBD84\uB2F9A-0446\uD638',
    '\uC8FC\uC18C \uACBD\uAE30\uB3C4 \uC131\uB0A8\uC2DC \uBD84\uB2F9\uAD6C \uD310\uAD50\uC5ED\uB85C192\uBC88\uAE38 16, 8\uCE35 806\uD638',
    '\uACE0\uAC1D\uC13C\uD130 contact@codam.co.kr',
]

const CopyRightThree = () => {
  return (
    <Fragment>
        <div className="copyright-three">
            <div className="container">
                <div className="row gx-4 gx-xxl-5 pt-40 pb-20 align-items-start">
                    <div className="col-12 pb-20">
                        <ul className="fot-list d-flex flex-wrap align-items-center codam-copyright__policy">
                           {policyLinks.map((val,i)=>(
                             <li key={i}>
                                {val.routerPath ? <Link to={val.routerPath}>{val.name}</Link> : <span>{val.name}</span>}
                            </li>
                           ))}
                        </ul>
                        <p className="mb-10 codam-copyright__meta">
                            {corporateInfo.join(' | ')}
                        </p>
                        <p className="mb-0 codam-copyright__copy">{'\u00A9 2026 CODAM Co., Ltd. All Rights Reserved.'}</p>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
  )
}

export default CopyRightThree
